export default __webpack_public_path__ + "img/dxauPgIV.8fd3bdf8.svg";